import constants from 'constants/index';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { handleSettingSkAndPkToLocalStorage } from 'utils/localStorageUtils';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import { handleRedirection } from 'utils/utils';

function UploadedTemplate(props) {
  const { rowData, userContext, isClientFileManager } = props;
  const history = useHistory();

  const { sk, pk, created_by_details, created_at, version_edited, version_created } = rowData || {};
  const { first_name, last_name, created_by_firm_user_id, created_by_contact_id, access_level } = created_by_details || {};

  const IsoFormattedDate = version_edited || version_created || created_at;
  const isClient = access_level?.toLowerCase() === 'client';
  let url = '';

  if (isClient) {
    const contactId = created_by_contact_id;
    url = contactId ? `/contacts/${contactId}` : '/contacts';
  } else {
    const firmUserId = created_by_firm_user_id;
    url = firmUserId ? `/settings/team-management/${firmUserId}` : '/settings/team-management';
  }

  const onClickCreatedBy = (e) => {
    e.preventDefault();
    if (!isClientFileManager) {
      handleSettingSkAndPkToLocalStorage(sk, pk);
      handleRedirection(history, url, rowData);
    }
  };

  return (
    <React.Fragment>
      <span className="p-column-title text-break">Date Uploaded</span>
      <div className="text-break d-inline-table file-manager-ellipsis-text ">
        <small
          className="file-manager-ellipsis-text"
          title={convertDateFromApiToUserTimezone(
            IsoFormattedDate,
            userContext?.userDetails?.timezone,
            constants.month_date_year_time_12_format
          )}
        >
          {convertDateFromApiToUserTimezone(IsoFormattedDate, userContext?.userDetails?.timezone, constants.month_date_year_time_12_format)}
        </small>

        {isClientFileManager && (
          <div
            className={`text-hint ms-0 file-manager-ellipsis-text ${!isClientFileManager ? 'cursor-pointer' : ''}`}
            onClick={onClickCreatedBy}
            title={first_name ? `${first_name} ${last_name || ''}` : undefined}
          >
            {created_by_firm_user_id && <i className="fas fa-user-tie me-2"></i>}
            {first_name ? `${first_name} ${last_name || ''}` : ''}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default UploadedTemplate;
